<div
  class="toast"
  [class.leaving]="toast.closing"
  [class.success]="toast.variant === 'success'"
  [class.info]="toast.variant === 'info'"
  [class.warning]="toast.variant === 'warning'"
  [class.error]="toast.variant === 'error'"
  [class.purple]="toast.variant === 'purple'"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="content">
    <div class="message">{{ toast.message }}</div>
  </div>

  <button type="button" class="close" aria-label="Close" (click)="onCloseClick()">
    ✕
  </button>
</div>
